import { computed, effect, Injectable, signal } from '@angular/core';
import { DelayedDbType } from './delayed-db.type';
import { AppIndexedDb } from '../db';
import { DB_DELAYED_REQUEST_TABLE } from '../db-types';
import { router } from '../../../modules/shared/shared.global-service';
import { currentUserId, selectedOrganizationId } from '../../current-user-id';

@Injectable({ providedIn: 'root' })
export class DelayedDb extends AppIndexedDb {

    public override tableName: string = DB_DELAYED_REQUEST_TABLE;

    public count = signal(0);
    public hasAny = computed(() => this.count() > 0);

    constructor() {
        super();

        effect(async () => {
            currentUserId();
            await this.clearOnUserChange();
        });

        effect(async () => {
            selectedOrganizationId();
            await this.recount();
        });
    }

    /**
     * Creates a store - MUST be called within onupgradeneeded event
     */
    public initializeStore(db: IDBDatabase): void {
        db.createObjectStore(this.tableName, { autoIncrement: true });
    }

    public setDatabase(db: IDBDatabase): void {
        this.db = db;
        this.recount().then();
    }

    public async store(resource: string, method: string, input: object): Promise<void> {
        await this.add({
            resource,
            method,
            input,
            url: router.url,
            storedAt: new Date(),
            organizationId: selectedOrganizationId(),
        } as DelayedDbType);
        this.count.update((it) => it + 1);
    }

    public override async clear(): Promise<void> {
        await super.clear();
        this.count.set(0);
    }

    public async deleteById(id: number): Promise<void> {
        if (!id) return;
        await this.delete(id);
        this.count.update((it) => Math.max(it - 1, 0));
    }

    public async listAll(): Promise<DelayedDbType[]> {
        const items = await this.getAllWithKeys();
        const orgaId = selectedOrganizationId();

        return items
            .filter((it: DelayedDbType) => it.organizationId == orgaId)
            ;
    }

    private async recount(): Promise<void> {
        if (!this.db) return;
        const count = (await this.listAll())?.length || 0;
        this.count.set(count);
    }

}
